import { useFilter } from './Filter';
import * as List from './List';
import { useOpenedSignalNotification } from './Notification/Notification';
import { use } from './Signal';

export const Signal = { use, List, useFilter, useOpenedSignalNotification };
